import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Digital Color Study: Triad </h1>

    
    <div className="imgs max700">
        <div>
            <img 
                src={require('../assets/drawing/colorTriad.jpg')} 
                data-skip-gallery
                />
        </div>
    </div>

    <p>I created this illustration during my art studies at Carnegie 
    Mellon University in the course <a target="_blank" href={require('../assets/drawing/s17_color.pdf')}>60-452</a>, "Advanced DP3: Color 
    Studio". The assignment was to incorporate a "color triad" palette into an image. A "color triad" is defined as a color scheme that 
    utilizes a special variant of the split-complementary color scheme, with equal distance between the colors on the color wheel. 
    All three colors being distributed evenly around the color wheel causes there to be no clear dominance of one color. I thought 
    this phenomena is well exhibited in tropical birds, who can naturally exhibit such opposing colors.</p>
    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.